<template>
    <div>
        <div class='footer-column-title'>
            Legal
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('https://www.majesticwinegroup.com', true)"><a class="footer-link">Majestic Wine Group</a></div>
            <div @click="onClickLink('https://www.majestic.co.uk/', true)"><a class="footer-link">Majestic Retail</a></div>
            <div @click="onClickLink('cookie-policy')"><a class="footer-link">Cookie Policy</a></div>
            <div @click="onClickLink('privacy-policy')"><a class="footer-link">Privacy Policy</a></div>
            <div @click="onClickLink('terms-and-conditions')"><a class="footer-link">Terms of Use</a></div>
            <div @click="onClickLink('/pdfs/majestic-anti-slavery-and-human-trafficking-policy.pdf', true)"><a class="footer-link">Modern Slavery Statement</a></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page, exteneral = false) {
            if(!exteneral){
                this.$router.push(`/${page}`);
            }
            else{
                window.location.href = page;
            }
        }
    }
}
</script>
